import { Component, OnInit } from '@angular/core';
import { MENU_ITEMS } from './em-pages-menu';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ngx-tables',
  template:  `
  <ngx-one-column-layout>
    <nb-menu [items]="menu"></nb-menu>
    <router-outlet></router-outlet>
  </ngx-one-column-layout>
`,
})//`<router-outlet></router-outlet>`,
export class EnterpriseComponent implements OnInit {
  
  public menu = [];

    constructor(private translate: TranslateService) {     
      
      this.translateMenu();      
      this.menu = MENU_ITEMS;
      
    }
  ngOnInit() {
    

}

private translateMenu(): void {
  
    MENU_ITEMS.forEach(menuItem => {
      try {
       
       this.translate.get( menuItem.title).subscribe((data: any) => {
        menuItem.title = data;
     
      });
      
      if(menuItem.children!==undefined) this.translateMenuTitle(menuItem.children);
      }
      catch (e) {
        //Key not found, don't change the menu item
        this.translateMenuTitle(menuItem.children);
    }
    });
  
}
private translateMenuTitle(menuItem): void {
 
 
  
  menuItem.forEach(mi => {
    try {
     
     this.translate.get( mi.title).subscribe((data: any) => {
      mi.title = data;
   
    });
    
    if(menuItem.children!==undefined) this.translateMenuTitle(menuItem.children);
    }
    catch (e) {
      //Key not found, don't change the menu item
      this.translateMenuTitle(menuItem.children);
  }
  });

  menuItem.forEach(item => {
  try {
    
    if(item.children===undefined || item.children.length==0) return;
    this.translateMenuTitle(menuItem.children);
    menuItem.children.forEach(mi => {
      
      this.translate.get( mi.titel).subscribe((data: any) => {
        mi.titel = data;
        
      });
    
    });
    
   
  
  }
  catch (e) {
      //Key not found, don't change the menu item
      if(item.children===undefined || item.children.length==0) return;
      this.translateMenuTitle(item.children);
      menuItem.children.forEach(mi => {
      
        this.translate.get( mi.titel).subscribe((data: any) => {
          mi.titel = data;
          
        });
        
      });
      this.translate.get( item.titel).subscribe((data: any) => {
        item.titel = data;
      });
  }
});

  
}

}
